import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import StaleRecordsCard from '../StaleRecordsCard';
import { getOverviewStaleProperties } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '@/components/Dashboard/customHooks/useFetchDashboard';
import { useTrackOverviewTab } from '@/components/Dashboard/customHooks/useTrackDashboard';
import { PROPERTIES_STATUS } from '@/components/Dashboard/constants';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';
import PropertyIcon from '@/public/images/dashboard/property.svg';

export default function PropertiesLastUpdate() {
  const dispatch = useDispatch();
  const { overviewStaleProperties, miniCards } = useSelector(
    (state) => state.DashboardSlice
  );
  const track = useTrackOverviewTab();
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  const { loading, hasFetched } = overviewStaleProperties;
  const { selectedStatusId, propertiesValue } = miniCards;
  const isAvailableStatusSelected =
    selectedStatusId === PROPERTIES_STATUS.AVAILABLE;

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewStaleProperties(query));
    },
    [],
    { hasFetched }
  );

  return (
    <Box __css={{ display: isAvailableStatusSelected ? 'block' : 'none' }}>
      <StaleRecordsCard
        id="overview-properties-last-update"
        ref={ref}
        loading={loading || isStale}
        data={overviewStaleProperties}
        icon={PropertyIcon}
        titleKey="PropertiesLastUpdate"
        titleInfoTooltipKey="PropertiesLastUpdateInfoTooltip"
        emptyStateTitleKey="HereYouWillSeePropertiesWithoutRecentUpdates"
        forceEmptyState={propertiesValue === 0}
        trackShowAll={(element) => track.propertyLastUpdate(element)}
        trackBar={() => track.propertyLastUpdate(TRACK_ELEMENT.ROW)}
      />
    </Box>
  );
}
